module.exports = __webpack_public_path__ + "static/card9-20e34ae979d8adf729d3653d75a7cf53.png";